export default __webpack_public_path__ + "assets/images/female-icon.png";